import {parse as qsParse} from "query-string";
import {Cloudinary} from "cloudinary-core";

const DEFAULT_CLOUD_NAME = "well-b-prod";
const CDN_URL = "://res.cloudinary.com/";

const EMAIL_SERVER_URL = "https://img.well-b.email/";

const extractInnerUrl = src => {
    const a = document.createElement("a");
    a.href = src;
    const urlParam = qsParse(a.search).url;
    const urlString = Array.isArray(urlParam) ? urlParam[0] : urlParam || "";
    return decodeURIComponent(typeof urlString === "string" ? urlString : "");
};

const extractCloudName = src => {
    const matches = src.match(/:\/\/res\.cloudinary\.com\/(.+?)\//);
    if (matches && matches.length > 1) {
        return matches[1];
    }

    return DEFAULT_CLOUD_NAME;
};

export const extractPublicIdAndCloudName = src => {
    if (src && src.indexOf(CDN_URL) >= 0) {
        const parts = src.split("/");
        const publicId = parts[parts.length - 1].split(".")[0];
        const cloudName = extractCloudName(src);

        const resourceTypeMatch = src.match(/:\/\/res\.cloudinary\.com\/[^/]+\/([^/]+)\/upload\//);
        const resourceType = resourceTypeMatch && resourceTypeMatch[1] ? resourceTypeMatch[1] : "image";

        const attachmentMatch = src.match(/fl_attachment:([^/,]+)/);
        const existingFilename = attachmentMatch ? decodeURIComponent(attachmentMatch[1]) : null;

        return {publicId, cloudName, resourceType, existingFilename};
    } else if (isEmailServerWithUrl(src)) {
        return extractPublicIdAndCloudName(extractInnerUrl(src));
    }

    return {publicId: null};
};

const isEmailServerWithUrl = src => src && src.indexOf(EMAIL_SERVER_URL) === 0 && src.indexOf("url=") >= 0;

const extractProxyUrl = src => {
    return isEmailServerWithUrl(src) ? extractInnerUrl(src) : null;
};

export const createUrlWithoutTransformations = (src, fileName) => {
    const {publicId, cloudName, resourceType} = extractPublicIdAndCloudName(src);

    if (publicId && cloudName) {
        const cloudinary = new Cloudinary({cloud_name: cloudName});
        const cleanUrl = cloudinary.url(publicId, {
            resource_type: resourceType || "image",
            attachment: fileName,
            secure: true
        });

        return cleanUrl;
    }

    return src;
};

export const createUrlWithTransformations = (src, width, height, transformations) => {
    const {publicId, cloudName, resourceType} = extractPublicIdAndCloudName(src);
    if (publicId && cloudName) {
        const cloudinary = new Cloudinary({cloud_name: cloudName});
        const transformedUrl = cloudinary.url(publicId, {
            width,
            height,
            crop: "fill",
            gravity: "center",
            fetch_format: "auto",
            secure: true,
            resource_type: resourceType || "image",
            ...transformations
        });

        return transformedUrl;
    } else if (isEmailServerWithUrl(src)) {
        return extractProxyUrl(src);
    }

    return src;
};

export const createAutoQualityVideoUrl = src => {
    const {publicId, cloudName} = extractPublicIdAndCloudName(src);
    if (publicId && cloudName) {
        const cloudinary = new Cloudinary({cloud_name: cloudName});
        return cloudinary.video_url(publicId, {
            quality: "auto",
            secure: true,
            fetch_format: "auto",
            resource_type: "video"
        });
    } else if (isEmailServerWithUrl(src)) {
        return extractProxyUrl(src);
    }

    return src;
};
